export default __webpack_public_path__ + "static/media/api-secure-icon.8e79f945.png";